import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import cn from 'classnames';

import SearchTab from '../SearchTab';

import CarryingCapacity from '../CarryingCapacity';
import YearOfCarManufacture from '../YearOfCarManufacture';
import RentPrice from '../RentPrice';
import Brand from '../Brand';
import Model from '../Model';
import PeriodTypes from '../PeriodTypes';
import GeoSuggest from '../GeoSuggest';
import TypeOfTransport from '../TypeOfTransport';
import TypeOfAdvert from '../TypeOfAdvert';
import MileageOrSpecialMachineryBlock from '../MileageOrSpecialMachineryBlock';
import WithDriver from '../WithDriver';

import { Item } from '../SearchTab/SearchTabStyles';
import { MarkAndModelContainer } from '../../SearchStyles';

const RentTabSearch = observer(() => {
  const {
    findTrucksStore: { countHideFilledFields },
    appStore: { width },
  } = useStores();

  return (
    <SearchTab countHideFilledFields={countHideFilledFields}>
      <Item className="select-advert-type">
        <TypeOfAdvert />
      </Item>
      <MarkAndModelContainer>
        <div className="wrapper">
          <Item className="brand-item">
            <Brand />
          </Item>
          <Item className="model-item">
            <Model />
          </Item>
        </div>
      </MarkAndModelContainer>
      <Item className="geo-block">
        <GeoSuggest />
      </Item>

      <Item className="type-block">
        <TypeOfTransport />
      </Item>
      <Item className={cn('year-block', width <= 512 && 'hide')}>
        <YearOfCarManufacture />
      </Item>

      <Item className="carrying-block hide">
        <CarryingCapacity />
      </Item>
      <Item className="millage-block hide">
        <MileageOrSpecialMachineryBlock />
      </Item>
      <Item className="price-block rent hide">
        <RentPrice />
        <PeriodTypes />
      </Item>

      <div className="checkbox-items">
        <div className="item hide">
          <WithDriver />
        </div>
      </div>
    </SearchTab>
  );
});

export default RentTabSearch;
